<template>
    <div>
        <div v-if="errorMessage">
            <zoezi-button @click="restartBankID()" class='my-2'>{{ $translate('Login failed. Try again') }}</zoezi-button>
        </div>
        <div v-else>
            <qrcode-vue v-if="qrcode" :value="qrcode" :size="size" level="H" class="ml-3"></qrcode-vue>
            <div class="my-2">{{$translate('Open the BankID app to continue')}}</div>
            <zoezi-button v-if='isMobileDevice' @click="openBankIDApp(autostarttoken)" class="my-2">{{ $translate('Open BankID on this device') }}</zoezi-button>
        </div>
    </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import { isMobile, getMobileDeviceType, isExpoApp } from '../util.js';

export default {
    name: 'zoezi-bankid',

    props: {
        size: {
            default: 300
        }
    },

    components: {
        QrcodeVue
    },

    data: () => ({
        time: 0,
        qrcode: null,

        status: null,
        processing: false,
        authID: null,
        autostarttoken: null,
        startingBankIDApp: false,
        errorMessage: null,

        unsubscribe: null
    }),

    watch: {
        errorMessage(text) {
            if (this.errorMessage) {
                text = this.$translate(text);
                this.$store.commit('showSnackBar', {text});
            }
        },
        status(value) {
            if (value == 'failed' || value == 'timeout') {
                if (!this.isMobileDevice && this.time < 45) this.startBankID();
                else this.errorMessage = 'BANKID_SIGNING_FAIL';
            }
        },
        qrcode() {
            this.time += 1;
        }
    },

    computed: {
        isMobileDevice() {
            return isMobile();
        }
    },

    methods: {
        isExpoApp,
        restartBankID() {
            this.errorMessage = null;
            this.startBankID();
        },
        startBankID() {
            if(this.processing) return;
            this.processing = true;
            try {
                if(Date.now() - Number(window.localStorage.getItem('lastBankIDLogin') || 0) < 5000) return;
                window.localStorage.setItem('lastBankIDLogin', Date.now());
            } catch {
                // Empty
            }
            let args = {site_id: this.$store.state.selectedSiteId};
            this.$api.post('/api/user/identify_bankid', null, args).then(response => {
                response.json().then(data => {
                    if (response.ok) {
                        this.authID = data.authId;
                        this.autostarttoken = data.autostarttoken;
                        this.unsubscribe = this.$api.subscribeChannel(data.authId, (resp) => {
                            this.status = resp.status;
                            if (this.status == 'complete') {
                                document.cookie = `session=${resp.session_id}; Path=/; Expires=${new Date('2040-01-01T10:00:00Z').toUTCString()}; Secure`;
                                this.$store.commit('setLoggedIn', {isLoggedIn: true, user: resp.data});
                                setTimeout(() => this.processing = false, 100);
                            } else if (this.status == 'qrcode') {
                                this.qrcode = resp.qrcode;
                            } else {
                                this.qrcode = null;
                                this.processing = false;
                            }

                        });
                    } else {
                        this.processing = false;
                        this.qrcode = null;
                        this.errorMessage = data.message;
                        this.autostarttoken = null;
                    }

                });
            })
        },
        openBankIDApp() {
            if (this.startingBankIDApp) {
                return;
            }

            const deviceType = getMobileDeviceType();

            if (isExpoApp() && window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'bankid', data: this.autostarttoken }));
            } else if (deviceType == 'ios') {
                let redirect_uri ='';
                window.location.href = 'https://app.bankid.com/?autostarttoken={0}&redirect={1}'.format(this.autostarttoken, encodeURIComponent(redirect_uri));
            } else if (deviceType == 'android') {
                window.open('bankid:///?autostarttoken={0}&redirect='.format(this.autostarttoken));
            } else {
                this.$store.commit('showSnackBar', {text: this.$translate('Device not supported')});
            }
            this.startingBankIDApp = true;
            setTimeout(() => {
                this.startingBankIDApp = false;
            }, 1000);
        },

    },
    mounted() {
        this.startBankID();
    },
    unmounted() {
        if (this.authID) {
            this.$api.post('/api/user/login_bankid_cancel', null, {id: this.authID});
        }
        this.unsubscribe?.();
    }
}
</script>
